import React from 'react';
import { Avatar, Typography, Button } from '@mui/material';
import Lottie from 'react-lottie';
import answer from './gifLottie/answer.json';
import hangup from './gifLottie/hangup.json';

export default function IncomingCall({ onAnswer, onReject, onHangup, answered }) {
    const optionsAnswer = {
        loop: true,
        autoplay: true,
        animationData: answer,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };
    const optionsHangup = {
        loop: true,
        autoplay: true,
        animationData: hangup,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '1rem' }}>
            {!answered ? <div style={{ display: 'flex', justifyContent: 'center', gap: '4rem', marginTop: '10%', marginLeft: '5%' }}>
                <div onClick={onReject} style={{ margin: "21px auto", transform: "rotate(130deg)" }}>
                    <Lottie options={optionsHangup}
                        height={80}
                        width={80} />
                </div>
                <div onClick={onAnswer}>
                    <Lottie options={optionsAnswer}
                        height={120}
                        width={120} />
                </div>
            </div> :
                <div style={{ display: 'flex', justifyContent: 'center', gap: '4rem', marginTop: '10%', marginLeft: '5%' }}>

                    <div onClick={onHangup} style={{ margin: "21px auto", transform: "rotate(130deg)" }}>
                        <Lottie options={optionsHangup}
                            height={80}
                            width={80} />
                    </div>

                </div>}

        </div>
    );
};

